import React from "react";
import { Typography } from "antd";
import DefaultParagraph from "./components/DefaultParagraph";
import { Bold, DefaultTitle } from "./components/ParagraphElement";
import { useHistory } from "react-router-dom";
const { Title } = Typography;

const TermsThai = () => {
  const history = useHistory();
  return (
    <div
      style={{
        margin: "20px auto",
        padding: 10,
      }}
    >
      <Title level={3} style={{ textAlign: "center" }}>
        ข้อกำหนดและเงื่อนไข
      </Title>
      <div className="w-max m-auto mb-6">
        <DefaultParagraph>
          ข้อกำหนดและเงื่อนไขฉบับนี้ (“<Bold>ข้อกำหนด</Bold>”)
          ได้จัดทำขึ้นสำหรับการอัดประจุไฟฟ้าที่สถานีบริการซึ่งดำเนินการโดย
          <Bold> บริษัท อรุณ พลัส จำกัด (“ARUN PLUS”)</Bold>{" "}
          สำนักงานที่ตั้งอยู่เลขที่ 555/1 ศูนย์เอนเนอร์ยี่คอมเพล็กซ์ อาคาร เอ
          ถนนวิภาวดีรังสิต แขวงจตุจักร เขตจตุจักร กทม. 10900
          ให้แก่ผู้ใช้ยานยนต์ไฟฟ้า (“<Bold>ผู้ใช้</Bold>”)
          โดยมีรายละเอียดดังต่อไปนี้
        </DefaultParagraph>

        <DefaultTitle>1.ข้อความสำคัญ</DefaultTitle>
        <DefaultParagraph leader="1.1.">
          <Bold>
            ผู้ใช้ต้องอ่านและทำความเข้าใจข้อกำหนดควบคู่กับนโยบายคุ้มครองข้อมูลส่วนบุคคล
            อย่างละเอียดเพื่อให้ผู้ใช้ได้ทราบถึงสิทธิและข้อผูกพันระหว่างผู้ใช้กับ
            ARUN PLUS และเพื่อความปลอดภัยของผู้ใช้
            และผู้ใช้ต้องยอมรับข้อกำหนดและนโยบายดังกล่าวก่อนลงทะเบียนเปิดบัญชีใช้บริการและเริ่มทำรายการผ่านแอปพลิเคชัน
          </Bold>
        </DefaultParagraph>
        <DefaultParagraph leader="1.2.">
          <Bold>
            ARUN PLUS
            สงวนสิทธิในการเปลี่ยนแปลงหรือยกเลิกข้อกำหนดหรือนโยบายคุ้มครองข้อมูลส่วนบุคคลทั้งหมดหรือบางส่วน
            ซึ่ง ARUN PLUS
            จะแจ้งการเปลี่ยนแปลงหรือยกเลิกให้ผู้ใช้ทราบผ่านทางแอปพลิเคชัน
            ซึ่งผู้ใช้ต้องยอมรับข้อกำหนดและหรือนโยบายที่เปลี่ยนแปลงก่อนเริ่มทำรายการผ่านแอปพลิเคชัน
          </Bold>
        </DefaultParagraph>
        <DefaultParagraph leader="1.3.">
          <Bold>
            ARUN PLUS
            อาจทำข้อกำหนดเฉพาะสำหรับการให้บริการบางประเภทโดยให้ถือว่าข้อกำหนดเฉพาะเป็นส่วนหนึ่งของข้อกำหนดนี้ด้วย
            ผู้ใช้ต้องอ่าน
            ทำความเข้าใจและยอมรับข้อกำหนดเฉพาะดังกล่าวก่อนการใช้บริการดังกล่าว
            ในกรณีที่ข้อกำหนดเฉพาะขัดแย้งกับข้อกำหนดนี้
            ให้ข้อกำหนดเฉพาะใช้บังคับแทนในส่วนที่ขัดแย้งกับข้อกำหนดนี้
          </Bold>
        </DefaultParagraph>

        <DefaultTitle>2.คำนิยาม</DefaultTitle>
        <DefaultParagraph>
          ให้คำที่ใช้ในข้อกำหนดมีความหมายตามที่กำหนดในข้อนี้
          เว้นแต่มีการระบุไว้เป็นอย่างอื่น
        </DefaultParagraph>
        <DefaultParagraph leader="2.1.">
          “<Bold>ข้อมูล</Bold>” หมายถึง ข้อความหรือข้อเท็จจริง
          ไม่ว่าจะปรากฎเป็นตัวอักษร ตัวเลข เสียง
          ภาพหรือรูปแบบอื่นที่สื่อความหมายได้
          รวมทั้งข้อมูลอิเล็กทรอนิกส์ที่สร้าง ส่ง รับ
          เก็บรักษาหรือประมวลผลด้วยวิธีการทางอิเล็กทรอนิกส์
        </DefaultParagraph>
        <DefaultParagraph leader="2.2.">
          “<Bold>เครื่องอัดประจุไฟฟ้า</Bold>” หมายถึง
          เครื่องอัดประจุไฟฟ้าสำหรับยานยนต์ไฟฟ้า (EV Charger)
          พร้อมอุปกรณ์ที่ใช้ในการเชื่อมต่อกับเครื่องอัดประจุไฟฟ้า เช่น สายไฟ
          เบรกเกอร์ ท่อเดินสายไฟ เป็นต้น ที่เป็นของ ARUN PLUS
        </DefaultParagraph>
        <DefaultParagraph leader="2.3.">
          “<Bold>ผู้ให้ใช้พื้นที่</Bold>” หมายถึง
          ผู้มีกรรมสิทธิ์หรือมีสิทธิครอบครองหรือมีสิทธิใช้ประโยชน์ในพื้นที่
          ซึ่งให้สิทธิแก่ ARUN PLUS ในการใช้พื้นที่จัดตั้งสถานีบริการ
        </DefaultParagraph>
        <DefaultParagraph leader="2.4.">
          “<Bold>บริการ</Bold>” หมายถึง
          การใช้สถานีบริการเพื่ออัดประจุไฟฟ้าสำหรับยานยนต์ไฟฟ้าผ่านเครื่องอัดประจุไฟฟ้า
          โดยมีการทำรายการผ่านแอปพลิเคชัน
        </DefaultParagraph>
        <DefaultParagraph leader="2.5.">
          “<Bold>ยานยนต์ไฟฟ้า</Bold>” หมายถึง ยานยนต์ชนิด Battery Electric
          Vehicle (BEV) และ Plug-In Hybrid Electric Vehicle (PHEV) ชนิด 2 ล้อและ
          4 ล้อ ที่รองรับการอัดประจุไฟฟ้าโดยเครื่องอัดประจุไฟฟ้าตามที่ ARUN PLUS
          กำหนด และยานยนต์ไฟฟ้าอื่น ๆ ตามที่ ARUN PLUS กำหนด
        </DefaultParagraph>
        <DefaultParagraph leader="2.6.">
          “<Bold>สถานีบริการ</Bold>” หมายถึง
          สถานีอัดประจุไฟฟ้าสำหรับยานยนต์ไฟฟ้า
          ซึ่งประกอบด้วยเครื่องอัดประจุไฟฟ้า
          พร้อมที่จอดยานยนต์ไฟฟ้าสำหรับผู้ใช้ในระหว่างการอัดประจุไฟฟ้า
        </DefaultParagraph>
        <DefaultParagraph leader="2.7.">
          “<Bold>แอปพลิเคชัน</Bold>” หมายถึง แอปพลิเคชันของ ARUN PLUS
          บนเครื่องมือสื่อสารทางอิเล็กทรอนิกส์{" "}
        </DefaultParagraph>

        <DefaultTitle>3.การลงทะเบียนเปิดบัญชีใช้บริการ</DefaultTitle>
        <DefaultParagraph leader="3.1.">
          ผู้ที่ประสงค์จะเข้าใช้บริการต้องเป็นผู้ที่มีใบอนุญาตขับรถโดยถูกต้องตามกฎหมาย
          หากผู้ใดไม่มีใบอนุญาตขับรถ แต่ประสงค์จะใช้บริการ
          ผู้นั้นต้องเป็นผู้บรรลุนิติภาวะและให้บุคคลที่มีใบอนุญาตขับรถโดยถูกต้องตามกฎหมายเป็นผู้ขับยานยนต์ไฟฟ้าเข้าจอดที่และนำออกจากสถานีบริการ
        </DefaultParagraph>
        <DefaultParagraph leader="3.2.">
          ในการใช้บริการครั้งแรก
          ผู้ใช้ต้องลงทะเบียนเปิดบัญชีการใช้บริการผ่านแอปพลิเคชัน
          โดยต้องแจ้งข้อมูล อันได้แก่ ชื่อ อีเมล รหัสผ่าน เบอร์โทรศัพท์
          เลขบัตรเครดิต วันหมดอายุและรายละเอียดอื่น ๆ ตามที่ ARUN PLUS กำหนด
          ซึ่งผู้ใช้อาจลงทะเบียนโดยการเชื่อมต่อกับบัญชีของ Apple Facebook หรือ
          Google ได้ ทั้งนี้
          ผู้ใช้รับรองว่าข้อมูลที่ลงทะเบียนเป็นข้อมูลของผู้ใช้และข้อมูลเป็นความจริง
          ถูกต้อง ครบถ้วน
          และผู้ใช้มีหน้าที่ต้องปรับปรุงและแก้ไขข้อมูลดังกล่าวให้ถูกต้องอยู่เสมอ
          มิฉะนั้นจะไม่สามารถเข้าใช้บริการได้
        </DefaultParagraph>

        <DefaultTitle>4.สิทธิและหน้าที่ในการใช้บริการ</DefaultTitle>
        <DefaultParagraph style={{ paddingLeft: 10 }} nostartspace underline>
          ยานยนต์ไฟฟ้าและการอัดประจุไฟฟ้า
        </DefaultParagraph>
        <DefaultParagraph leader="4.1.">
          ผู้ใช้ต้องใช้สถานีบริการ เครื่องอัดประจุไฟฟ้า
          พื้นที่ที่จัดให้จอดยานยนต์ไฟฟ้าและแอปพลิเคชันเฉพาะเพื่อใช้อัดประจุไฟฟ้าให้กับยานยนต์ไฟฟ้าเท่านั้น
          และจะไม่ใช้บริการในทางที่ขัดต่อกฎหมาย
          ข้อกำหนดหรือหลักปฏิบัติที่ใช้โดยทั่วไปสำหรับการใช้สถานีบริการ
        </DefaultParagraph>
        <DefaultParagraph leader="4.2.">
          ผู้ใช้ต้องศึกษาและปฏิบัติตามวิธีการใช้เครื่องอัดประจุไฟฟ้าตามที่ระบุไว้ในคู่มือการใช้เครื่องอัดประจุไฟฟ้า
          และคู่มือการอัดประจุไฟฟ้าของบริษัทผู้ผลิตยานยนต์ไฟฟ้า
          รวมถึงต้องปฏิบัติตามคำแนะนำและวิธีการใช้ในแอปพลิเคชัน สถานีบริการ
          และเครื่องอัดประจุไฟฟ้า (หากมี)
        </DefaultParagraph>
        <DefaultParagraph leader="4.3.">
          ผู้ใช้รับรองว่ายานยนต์ไฟฟ้าที่เข้าใช้บริการมีคุณลักษณะตรงตามที่ ON-I
          ON กำหนด
        </DefaultParagraph>
        <DefaultParagraph leader="4.4.">
          ผู้ใช้รับรองว่าผู้ใช้เป็นเจ้าของหรือมีสิทธิครอบครองยานยนต์ไฟฟ้าโดยถูกต้องตามกฎหมาย
          ยานยนต์ไฟฟ้าที่นำมาใช้กับเครื่องอัดประจุไฟฟ้าอยู่ในสภาพที่ดี
          และใช้ระบบและอุปกรณ์ที่เกี่ยวกับการรับจ่ายประจุไฟฟ้าของบริษัทผู้ผลิตยานยนต์ไฟฟ้า
        </DefaultParagraph>
        <DefaultParagraph leader="4.5.">
          ผู้ใช้ต้องใช้เครื่องอัดประจุไฟฟ้าอย่างระมัดระวังและคำนึงถึงความปลอดภัยของชีวิตและทรัพย์สินของตนเองและผู้อื่น
        </DefaultParagraph>
        <DefaultParagraph leader="4.5." hideleader>
          หากเครื่องอัดประจุไฟฟ้าขัดข้องหรือชำรุด หรือหากพบความผิดปกติใด ๆ ก่อน
          ในระหว่าง หรือหลังการอัดประจุไฟฟ้า
          หรือเกิดความเสียหายหรืออันตรายต่อบุคคล เครื่องอัดประจุไฟฟ้า
          ยานยนต์หรือทรัพย์สินอื่นใด ๆ ภายในสถานีบริการหรือบริเวณข้างเคียง
          ผู้ใช้ต้องแจ้งศูนย์บริการของ ARUN PLUS
          หรือแจ้งเหตุผ่านแอปพลิเคชันโดยทันที
        </DefaultParagraph>
        <DefaultParagraph leader="4.6.">
          ผู้ใช้ต้องปฏิบัติตามเงื่อนไขการใช้พื้นที่ของผู้ให้สิทธิใช้พื้นที่
          ตลอดจนไม่จอดยานยนต์ไฟฟ้า หรือวางสิ่งของกีดขวางทาง
          หรือรบกวนการใช้บริการของผู้ใช้รายอื่นหรือทางเดินรถของบุคคลอื่น
        </DefaultParagraph>
        <DefaultParagraph leader="4.7.">
          ผู้ใช้รับทราบว่าการใช้บริการสถานีบริการไม่ใช่เป็นการรับบริการฝากยานยนต์ไฟฟ้า
          และ ARUN PLUS จะไม่รับผิดชอบต่อความเสียหาย หรือสูญหายใด ๆ
          ต่อยานยนต์ไฟฟ้าหรือทรัพย์สินของผู้ใช้ขณะจอดอยู่ในสถานีบริการ
        </DefaultParagraph>
        <DefaultParagraph style={{ paddingLeft: 10 }} nostartspace underline>
          การจองเวลา
        </DefaultParagraph>
        <DefaultParagraph leader="4.8.">
          ผู้ใช้สามารถจองเวลาการใช้เครื่องอัดประจุไฟฟ้าผ่านแอปพลิเคชันล่วงหน้าได้ไม่เกิน
          1 วัน
        </DefaultParagraph>
        <DefaultParagraph leader="4.9.">
          หากผู้ใช้ต้องการยกเลิกการจองก่อนเวลาที่ทำการจอง
          ผู้ใช้จะต้องยกเลิกการจองผ่านแอปพลิเคชันตามเวลาและวิธีการที่ ARUN PLUS
          กำหนด
        </DefaultParagraph>
        <DefaultParagraph leader="4.9." hideleader>
          หากผู้ใช้ที่จองเวลาไม่ทำการเริ่มการใช้บริการ (Check in)
          ภายในระยะเวลาที่ ARUN PLUS กำหนด ARUN PLUS
          มีสิทธิยกเลิกการจองของผู้ใช้
          โดยไม่จำเป็นต้องได้รับความยินยอมของผู้ใช้ก่อน และ ARUN PLUS
          สงวนสิทธิ์ในการเรียก
          ค่าปรับอันเกิดจากการยกเลิกการจองจากผู้ใช้ในอัตราที่ ARUN PLUS กำหนด
        </DefaultParagraph>
        <DefaultParagraph style={{ paddingLeft: 10 }} nostartspace underline>
          การเริ่มการใช้บริการ (Check in)
        </DefaultParagraph>
        <DefaultParagraph leader="4.10.">
          ผู้ใช้ต้องนำยานยนต์ไฟฟ้าจอดที่สถานีบริการตามตำแหน่งพื้นที่ที่จัดให้จอดยานยนต์ไฟฟ้าและเริ่มทำรายการเพื่ออัดประจุไฟฟ้า
          (Check in)
          ในแอปพลิเคชันทันทีที่จอดและก่อนที่จะเริ่มการอัดประจุไฟฟ้าเข้ายานยนต์ไฟฟ้า
        </DefaultParagraph>
        <DefaultParagraph style={{ paddingLeft: 10 }} nostartspace underline>
          การสิ้นสุดการใช้บริการ (Check out)
        </DefaultParagraph>
        <DefaultParagraph leader="4.11.">
          ผู้ใช้ต้องนำยานยนต์ไฟฟ้าจอดที่สถานีบริการตามตำแหน่งพื้นที่ที่จัดให้จอดยานยนต์ไฟฟ้าและเริ่มทำรายการเพื่ออัดประจุไฟฟ้า
          (Check in)
          ในแอปพลิเคชันทันทีที่จอดและก่อนที่จะเริ่มการอัดประจุไฟฟ้าเข้ายานยนต์ไฟฟ้า
        </DefaultParagraph>
        <DefaultParagraph leader="4.11." hideleader>
          ในกรณีที่ระยะเวลาที่จองสิ้นสุดโดยไม่มีการจองเวลาต่อ
          หรือทำรายการใช้บริการต่อและผู้ใช้ไม่ออกจากรายการใช้บริการ (Check out)
          หรือไม่นำยานยนต์ไฟฟ้าออกจากสถานีบริการ ARUN PLUS
          สงวนสิทธิในการคิดค่าปรับในอัตราตามที่ ARUN PLUS กำหนด และ ARUN PLUS
          มีสิทธิที่จะดำเนินการใด ๆ
          เพื่อนำยานยนต์ไฟฟ้าของผู้ใช้ออกจากพื้นที่สถานีบริการได้
          โดยผู้ใช้ต้องเป็นผู้รับผิดชอบค่าใช้จ่ายใด ๆ
          ที่เกิดขึ้นจากการดำเนินการดังกล่าว (หากมี){" "}
        </DefaultParagraph>
        <DefaultParagraph style={{ paddingLeft: 10 }} nostartspace underline>
          กรรมสิทธิ์และการใช้
        </DefaultParagraph>
        <DefaultParagraph leader="4.12.">
          ผู้ใช้รับทราบว่าเครื่องอัดประจุไฟฟ้าเป็นกรรมสิทธิ์ของ ARUN PLUS
          โดยผู้ใช้มีสิทธิในการใช้เครื่องอัดประจุไฟฟ้าเฉพาะตามเวลาที่จองไว้และตามวัตถุประสงค์ที่ระบุไว้ในข้อกำหนดนี้เท่านั้น
          ผู้ใช้ไม่มีสิทธิปรับเปลี่ยน ซ่อมแซม เชื่อมต่อ หรือถอดอุปกรณ์ใด ๆ
          ของเครื่องอัดประจุไฟฟ้าด้วยตนเอง{" "}
        </DefaultParagraph>

        <DefaultTitle>5.สิทธิและหน้าที่ในการใช้แอปพลิเคชัน</DefaultTitle>
        <DefaultParagraph leader="5.1.">
          บัญชีแต่ละบัญชีมีไว้เพื่อใช้งานเฉพาะบุคคล
          โดยผู้ใช้ต้องเก็บรักษาชื่อบัญชีและรหัสผ่านไว้เป็นความลับ
          โดยไม่นำไปให้ผู้อื่นใช้ หากผู้ใช้นำไปให้บุคคลอื่นใช้
          ผู้ใช้ซึ่งเป็นเจ้าของบัญชีจะต้องรับผิดชอบต่อค่าใช้จ่ายที่เกิดขึ้นและความเสียหายที่
          ARUN PLUS ได้รับจากการใช้บริการของบุคคลนั้น
        </DefaultParagraph>
        <DefaultParagraph leader="5.1." hideleader>
          หากผู้ใช้พบการทำรายการที่เกิดขึ้นที่ไม่ได้เกิดจากการทำรายการของผู้ใช้
          ผู้ใช้ต้องแจ้งให้ ARUN PLUS ทราบโดยทันที
        </DefaultParagraph>
        <DefaultParagraph leader="5.2.">
          ผู้ใช้รับทราบว่าข้อมูล แอปพลิเคชัน ปัญญาประดิษฐ์ (Artificial
          intelligence) เทคโนโลยี วิธีการทางเทคนิค วิทยาการความรู้ (Know-How)
          ระบบอิเล็กทรอนิกส์ ทรัพย์สินทางปัญญา
          และสิทธิอื่นใดที่ได้นำมาให้บริการภายใต้ข้อกำหนดนี้เป็นสิทธิของ ARUN
          PLUS
          โดยผู้ใช้ตกลงว่าจะไม่กระทำการใดซึ่งจะเป็นการละเมิดสิทธิและทรัพย์สินทางปัญญาของ
          ARUN PLUS
        </DefaultParagraph>
        <DefaultParagraph leader="5.3.">
          ผู้ใช้จะไม่เข้าใช้หรือพยายามเข้าใช้บริการสถานีบริการโดยวิธีอื่น
          รวมถึงการใช้วิธีการอัตโนมัติ เช่นการใช้สคริปต์
          (ชุดคำสั่งหรือภาษาคอมพิวเตอร์เพื่อแฝงตัวเข้าสู่ระบบสมาชิก)
          นอกจากตามวิธีการที่ ARUN PLUS กำหนดไว้
          เว้นแต่ผู้ใช้จะได้รับอนุญาตเป็นลายลักษณ์อักษรจาก ARUN PLUS
        </DefaultParagraph>
        <DefaultParagraph leader="5.4.">
          ผู้ใช้จะไม่ทำหรือมีส่วนร่วมในการขัดขวางหรือรบกวนการใช้งานแอปพลิเคชัน
          รวมทั้งเข้าฐานข้อมูล แก้ไขหรือดำเนินการใด ๆ
          ในระบบแม่ข่ายและเครือข่ายที่เชื่อมต่อกับการใช้งานของแอปพลิเคชันอย่างเด็ดขาด
        </DefaultParagraph>
        <DefaultParagraph leader="5.5.">
          ผู้ใช้มีสิทธิในการลบบัญชีของตนได้ทุกเมื่อ
          ในกรณีที่ผู้ใช้ไม่มีการใช้งานในบัญชีใดเป็นเวลามากกว่า 1 ปี
          นับแต่วันที่มีการเปิดใช้งานบัญชีดังกล่าวครั้งล่าสุด ARUN PLUS
          สงวนสิทธิในการลบบัญชีดังกล่าวออกจากระบบโดยไม่ต้องบอกกล่าวล่วงหน้าแก่ผู้ใช้
        </DefaultParagraph>
        <DefaultParagraph leader="5.6.">
          การใช้บริการและการดำเนินการใด ๆ ผ่านแอปพลิเคชัน
          ให้ถือว่ามีผลใช้บังคับโดยถูกต้อง สมบูรณ์ ผูกพันผู้ใช้
          และเป็นการดำเนินการโดยชอบและใช้บังคับได้ตามกฎหมาย
          และถือเป็นหลักฐานแห่งธุรกรรมอิเล็กทรอนิกส์และสามารถใช้เป็นต้นฉบับเพื่อเป็นพยานหลักฐานในกระบวนการพิจารณาทางกฎหมายได้
          โดย ARUN PLUS ไม่ต้องสอบถามไปยังผู้ใช้หรือตรวจสอบความถูกต้อง อำนาจ
          หรือตัวตนของผู้ใช้ และ ผู้ใช้ไม่ต้องลงนามในเอกสาร
          เว้นแต่จะกำหนดไว้เป็นอย่างอื่นโดยชัดแจ้ง
        </DefaultParagraph>
        <DefaultParagraph leader="5.7.">
          ผู้ใช้ต้องให้สิทธิ ARUN PLUS
          เข้าถึงตำแหน่งของเครื่องมือสื่อสารที่ติดตั้งแอปพลิเคชัน
          หากประสงค์ที่จะรับคำแนะนำจุดที่ตั้งสถานีบริการ
        </DefaultParagraph>
        <DefaultParagraph leader="5.8.">
          การเชื่อมโยงไปยังเว็บไซต์อื่นเป็นเพียงการอำนวยความสะดวกแก่ผู้ใช้เท่านั้น
          ARUN PLUS มิได้มีส่วนเกี่ยวข้องหรือมีอำนาจควบคุมหรือรับรองความถูกต้อง
          ความน่าเชื่อถือของเว็บไซต์นั้น ๆ ARUN PLUS ไม่รับผิดชอบต่อเนื้อหาใด ๆ
          ที่แสดงบนเว็บไซต์อื่นที่เชื่อมโยงมายังเว็บไซต์
          หรือรับผิดชอบต่อความเสียหายใด ๆ
          ที่เกิดขึ้นจากการเข้าเยี่ยมชมเว็บไซต์ดังกล่าว
        </DefaultParagraph>

        <DefaultTitle>6.สิทธิและหน้าที่ของ ARUN PLUS </DefaultTitle>
        <DefaultParagraph leader="6.1.">
          ARUN PLUS ให้บริการสถานีบริการอัดประจุไฟฟ้าสำหรับยานยนต์ไฟฟ้า
          โดยผู้ใช้สามารถค้นหาสถานีบริการผ่านแอปพลิเคชันเพื่อทำรายการจองใช้เครื่องอัดประจุไฟฟ้า
          เลือกเวลาการใช้เครื่องอัดประจุไฟฟ้า
          กำหนดเวลาให้เครื่องอัดประจุไฟฟ้าเริ่มและหยุดทำงาน
          เชื่อมต่อเครื่องอัดประจุไฟฟ้าเข้ากับระบบรับประจุไฟฟ้าของยานยนต์ไฟฟ้าด้วยตนเอง
          รวมถึงการชำระค่าบริการ และค่าปรับ (หากมี) ทั้งนี้
          เครื่องอัดประจุไฟฟ้าของ ARUN PLUS
          สามารถใช้อัดประจุไฟฟ้าสำหรับยานยนต์ไฟฟ้าประเภทที่มีคุณสมบัติตรงตามที่
          ARUN PLUS กำหนดเท่านั้น
        </DefaultParagraph>
        <DefaultParagraph leader="6.2.">
          ช่วงระยะเวลาในการให้บริการของแต่ละสถานีบริการจะเป็นไปตามเงื่อนไขและข้อกำหนดของผู้ให้สิทธิใช้พื้นที่แต่ละแห่ง
        </DefaultParagraph>
        <DefaultParagraph leader="6.3.">
          ARUN PLUS
          จะใช้ความพยายามตามสมควรเพื่อให้ผู้ใช้สามารถใช้สถานีบริการได้ตามปกติอยู่เสมอ
          แต่การให้บริการอาจล่าช้าหรือหยุดชะงักเนื่องจากความขัดข้องในการจ่ายไฟฟ้าของการไฟฟ้าหรือผู้ให้สิทธิใช้พื้นที่
          ความขัดข้องของระบบแอปพลิเคชัน
          ความขัดข้องในระบบอินเตอร์เน็ตหรือสัญญาณของระบบเครื่องมือสื่อสาร
          การที่เครื่องอัดประจุไฟฟ้าชำรุดหรือขัดข้อง หรือเหตุอื่นๆ เช่น
          เพื่อความปลอดภัยของผู้ใช้
          หรือความล่าช้าของการใช้บริการของผู้ใช้รายก่อน โดย ARUN PLUS
          ไม่ถือว่าปฏิบัติผิดหน้าที่ใด ๆ ตามข้อกำหนดนี้
          และไม่ต้องรับผิดชอบหากมีความเสียหายเกิดขึ้น
        </DefaultParagraph>
        <DefaultParagraph leader="6.4.">
          ARUN PLUS ได้ติดตั้งระบบการวัดหน่วยไฟฟ้าไว้ ณ เครื่องอัดประจุไฟฟ้า
          และระบบจะแสดงข้อมูลการวัดหน่วยไฟฟ้าบนหน้าจอเครื่องมือสื่อสารที่ผู้ใช้กำหนดไว้ในแอปพลิเคชัน
        </DefaultParagraph>
        <DefaultParagraph leader="6.5.">
          ARUN PLUS มีสิทธิรวบรวมและประมวลผลข้อมูลของผู้ใช้
          เพื่อวัตถุประสงค์ในการระบุตัวตนสมาชิก
        </DefaultParagraph>
        <DefaultParagraph leader="6.6.">
          ARUN PLUS
          มีสิทธิหยุดให้บริการหรือปฏิเสธไม่ให้ผู้ใช้เข้าถึงบริการหรือส่วนหนึ่งส่วนใดของบริการได้ตลอดเวลา
          ไม่ว่าด้วยเหตุผลใดก็ตาม โดยไม่จำเป็นที่จะต้องแจ้งให้ผู้ใช้ทราบล่วงหน้า
          ARUN PLUS
          มีสิทธิในการเปลี่ยนแปลงหรือปรับปรุงการให้บริการทั้งหมดหรือบางส่วนได้ตามที่
          ARUN PLUS เห็นสมควร โดยไม่จำเป็นต้องแจ้งให้ผู้ใช้ทราบก่อนล่วงหน้า
        </DefaultParagraph>

        <DefaultTitle>7.การชำระเงิน</DefaultTitle>
        <DefaultParagraph leader="7.1.">
          ผู้ใช้ต้องชำระค่าบริการในอัตราตามที่ระบุไว้ในรายการที่ผู้ใช้ทำในแอปพลิเคชัน
          โดยสถานีบริการแต่ละแห่งจะคิดค่าบริการในอัตราที่แตกต่างกัน ทั้งนี้
          ขึ้นอยู่กับสถานที่ตั้งและขนาดของเครื่องอัดประจุไฟฟ้า
          โดยรูปแบบและวิธีการชำระค่าบริการจะเป็นไปตามที่ ARUN PLUS กำหนด
        </DefaultParagraph>
        <DefaultParagraph leader="7.2.">
          ในกรณีที่มีการใช้บริการในแต่ละครั้งเกินกว่าค่าบริการที่ระบุไว้ในรายการที่ผู้ใช้ทำในแอปพลิเคชันก่อนที่จะเข้าใช้บริการ 
          ผู้ใช้ตกลงจะชำระค่าใช้บริการส่วนเกินและค่าปรับที่เกิดขึ้นให้แก่ ARUN PLUS เพิ่มเติม
        </DefaultParagraph>
        <DefaultParagraph leader="7.3.">
          ในกรณีที่ผู้ใช้เลือกชำระค่าบริการผ่านบัตรเครดิต
          ผู้ใช้รับทราบว่าในการใช้บริการในแต่ละครั้งจะต้องมีการกันวงเงินบัตรเครดิตของผู้ใช้
          โดยผู้ใช้ยินยอมให้ ARUN PLUS ทำการกันวงเงินบัตรเครดิต
          (Pre-authorization) ทุกครั้งก่อนการใช้บริการ
          ซึ่งการกันวงเงินดังกล่าวยังไม่ถือว่าเป็นการเรียกเก็บค่าบริการและตัดยอดบัตรเครดิต
          ทั้งนี้ จำนวนวงเงินที่กันไว้จะเป็นไปตามนโยบายและขั้นตอนการให้บริการของ
          ARUN PLUS
        </DefaultParagraph>
        <DefaultParagraph leader="7.3." hideleader>
          การชำระเงินและตัดยอดบัตรเครดิตจะดำเนินการระหว่างขั้นตอนการออกจากรายการ
          (Check out) หากยอดการใช้บริการจริงต่ำกว่ายอดวงเงินที่กันไว้
          ผู้ใช้จะได้รับคืนส่วนต่างที่เกินภายในระยะเวลาการดำเนินการของธนาคารเจ้าของบัตร
          กรณีทั่วไป หากทำรายการและใช้บริการเสร็จสิ้นก่อนเวลา 21.00 น.
          ผู้ใช้จะได้รับคืนส่วนต่างที่เกินภายในวันที่ใช้บริการ
          แต่หากผู้ใช้ทำรายการและใช้บริการเสร็จสิ้นหลังเวลา 21.00 น.
          ผู้ใช้จะได้รับส่วนต่างคืน ภายใน 7-14
          วันทำการระยะเวลาขึ้นอยู่กับธนาคารเจ้าของบัตร
        </DefaultParagraph>
        <DefaultParagraph leader="7.4.">
          ในกรณีที่ผู้ใช้เลือกชำระค่าบริการผ่านบัตรเครดิต หาก ARUN PLUS
          ไม่สามารถกันวงเงินบัตรเครดิตได้เนื่องจากเกินวงเงินบัตรเครดิตของผู้ใช้
          ผู้ใช้จะไม่สามารถใช้บริการใด ๆ ภายในสถานีบริการได้
        </DefaultParagraph>

        <DefaultTitle>8.การจำกัดความรับผิด</DefaultTitle>
        <DefaultParagraph leader="8.1.">
          ARUN PLUS ไม่รับผิดชอบในความเสียหายใด ๆ 
          อันเกิดแก่ยานยนต์ไฟฟ้าหรือทรัพย์สินของผู้ใช้อันเนื่องมาจากการใช้บริการของผู้ใช้เองหรือการกระทำของผู้อื่น 
          เว้นแต่ความเสียหายดังกล่าวเกิดจากการจงใจกระทำความผิด 
          หรือประมาทเลินเล่ออย่างร้ายแรงของ ARUN PLUS ซึ่งในกรณีดังกล่าว ARUN PLUS 
          ตกลงชดใช้ค่าเสียหายสำหรับความเสียหายที่เกิดขึ้นกับผู้ใช้โดยตรงและเป็นความเสียหายที่สามารถพิสูจน์ได้เท่านั้น 
          และไม่รับผิดชอบสำหรับความเสียหายที่เกิดขึ้นอันมิใช่จากผลโดยตรงหรือค่าเสียหายในพฤติการณ์พิเศษ
        </DefaultParagraph>
        <DefaultParagraph leader="8.2.">
          ผู้ใช้ต้องรับผิดชอบต่อความความเสียหายใด ๆ 
          ตลอดจนค่าใช้จ่ายอื่นใดที่เกิดขึ้นกับหรือก่อให้เกิดความเสียหายต่อ ARUN PLUS 
          อันเกิดขึ้นจากการที่ผู้ใช้ไม่ปฏิบัติตามข้อกำหนดนี้ หรือเกิดข้อเรียกร้องใด ๆ 
          จากบุคคลภายนอกอันทำให้ ARUN PLUS จะต้องรับผิดชอบชดใช้ในความเสียหายดังกล่าว
        </DefaultParagraph>

        <DefaultTitle>
          9.การเก็บข้อมูลส่วนบุคคลและการรักษาข้อมูลที่เป็นความลับ
        </DefaultTitle>
        <DefaultParagraph leader="9.1.">
          ลักษณะข้อมูล วัตถุประสงค์ในการเก็บ ใช้ และเปิดเผยข้อมูลส่วนบุคคล
        </DefaultParagraph>
        <DefaultParagraph leader="9.1.1" style={{ margin: "auto auto 1em 20px", maxWidth: 780 }}>
          เก็บและใช้ ชื่อ นามสกุล ประวัติการใช้งานและข้อมูลการติดต่อของผู้ใช้ 
          เพื่อประโยชน์ในการประเมิน ปรับปรุง และพัฒนาผลิตภัณฑ์ การให้บริการ 
          และการดำเนินงานของ ARUN PLUS และเพื่อการร่วมกิจกรรมและรายการส่งเสริมการขายต่าง ๆ 
          ของ ARUN PLUS
        </DefaultParagraph>
        <DefaultParagraph leader="9.1.2" style={{ margin: "auto auto 1em 20px", maxWidth: 780 }}>
          เก็บและใช้ ชื่อ นามสกุล ประวัติการใช้งานและข้อมูลการติดต่อของผู้ใช้ 
          เพื่อวิเคราะห์ วิจัย และพัฒนาผลิตภัณฑ์ และบริการของ ARUN PLUS 
          ให้เหมาะสมกับความต้องการของผู้ใช้
        </DefaultParagraph>
        <DefaultParagraph leader="9.1.3" style={{ margin: "auto auto 1em 20px", maxWidth: 780 }}>
          เก็บและใช้ ชื่อ นามสกุล และข้อมูลการติดต่อของผู้ใช้ 
          เพื่อแจ้งข้อมูลข่าวสารเกี่ยวกับผลิตภัณฑ์หรือบริการของ ARUN PLUS 
          กิจกรรมทางการตลาด รายการส่งเสริมการขายต่างๆ แคมเปญ 
          สิทธิประโยชน์ การเชิญชวนเข้าร่วมกิจกรรมหรือโครงการ 
          และการนำเสนอผลิตภัณฑ์หรือบริการต่างๆ ของ ARUN PLUS ผ่านทาง 
          ไปรษณีย์อิเล็กทรอนิกส์ โทรศัพท์ ข้อความ SMS ทางโทรศัพท์มือถือ
        </DefaultParagraph>
        <DefaultParagraph leader="9.1.4" style={{ margin: "auto auto 1em 20px", maxWidth: 780 }}>
          เปิดเผย ชื่อ นามสกุล ประวัติการใช้งานและข้อมูลการติดต่อของผู้ใช้ 
          ให้แก่บริษัทย่อย บริษัทในเครือ และบริษัทที่เกี่ยวข้องใดๆ 
          เพื่อวัตถุประสงค์ในการดำเนินธุรกิจ ประกอบการเบิกจ่ายและปิดค่าใช้จ่ายที่เกี่ยวข้องกับหน่วยงานบัญชีการเงิน 
          และการบริหารงานภายใน
        </DefaultParagraph>
        <DefaultParagraph leader="9.2.">
          ผู้ใช้สามารถร้องขอให้ทาง ARUN PLUS ลบบัญชีของคุณหรือเอาข้อมูลส่วนบุคคลออก 
          โดยสามารถส่งอีเมลล์มาที่ email: onionevcharger@gmail.com
        </DefaultParagraph>
        <DefaultParagraph >
        รายละเอียดเพิ่มเติมเกี่ยวกับนโยบายการคุ้มครองข้อมูลส่วนบุคคล สามารถศึกษาได้ใน <span style={{ color: '#2F80ED',fontWeight:'bold' }} className='hover:opacity-80 cursor-pointer' onClick={() => {
            history.push('/privacy-polices?languages=th')
          }}>นโยบายการคุ้มครองข้อมูลส่วนบุคคล</span>
        </DefaultParagraph>


        <DefaultTitle>10.ความผูกพันระหว่าง ARUN PLUS กับผู้ใช้</DefaultTitle>
        <DefaultParagraph>
          ข้อกำหนดและเงื่อนไขต่าง ๆ ตามข้อกำหนดนี้ไม่ก่อให้เกิดความผูกพันระหว่าง
          ARUN PLUS กับผู้ใช้ในฐานะนายจ้างกับลูกจ้าง หรือในฐานะตัวการหรือตัวแทน
          และ ARUN PLUS ไม่ต้องรับผิดชอบในการกระทำใด ๆ
          ของผู้ใช้นอกเหนือไปจากที่ได้กำหนดไว้ในข้อกำหนดนี้ หากปรากฏว่า ARUN
          PLUS ถูกเรียกร้องด้วยประการใด ๆ จากบุคคลภายนอกอันเกิดขึ้นจากผู้ใช้
          ผู้ใช้จะต้องเป็นผู้รับผิดชอบแต่เพียงผู้เดียว
        </DefaultParagraph>

        <DefaultTitle>11.กฎหมายที่ใช้บังคับ</DefaultTitle>
        <DefaultParagraph>
          ข้อกำหนดนี้ ให้ใช้บังคับและตีความตามกฎหมายไทย
        </DefaultParagraph>

        <DefaultTitle>12.ข้อมูลข่าวสารและคำบอกกล่าว</DefaultTitle>
        <DefaultParagraph leader="12.1.">
          เพื่อประโยชน์ของผู้ใช้ ARUN PLUS อาจส่งข้อมูลข่าวสาร เช่น
          ข้อมูลเครื่องอัดประจุไฟฟ้าและบริการต่าง ๆ ข้อมูลทางการตลาด
          และรายการส่งเสริมการขาย เป็นต้น ไปยังที่อยู่อิเล็กทรอนิกส์ต่าง ๆ
          ของผู้ใช้ เช่น ในแอปพลิเคชัน เว็บไซต์ อีเมล์ และหมายเลขโทรศัพท์มือถือ
          เป็นต้น
          โดยผู้ใช้สามารถบอกเลิกหรือปฏิเสธการรับข้อมูลดังกล่าวได้ตามช่องทางที่
          ARUN PLUS กำหนด
        </DefaultParagraph>
        <DefaultParagraph leader="12.2.">
          คำบอกกล่าว เอกสาร หนังสือ หรือข้อมูลใด ๆ ที่ ARUN PLUS
          ได้ส่งไปยังผู้ใช้ตามที่อยู่ หมายเลขโทรศัพท์ อีเมล
          ตามที่ผู้ใช้ได้ให้ไว้กับ ARUN PLUS หรือตามที่ ARUN PLUS
          ได้รับแจ้งแก้ไขเปลี่ยนแปลงแล้ว โดยทางไปรษณีย์ ข้อความ SMS หรืออีเมล
          หรือการสื่อสารทางอิเล็กทรอนิกส์อื่นใด (หากมี)
          ให้ถือว่าได้ส่งให้ผู้ใช้แล้วโดยชอบ และผู้ใช้ได้ทราบถึงคำบอกกล่าว
          เอกสาร หนังสือ หรือข้อมูลนั้น ๆ แล้ว
        </DefaultParagraph>

        <DefaultParagraph nostartspace>
          บรรดาคำบอกกล่าว เอกสาร หนังสือ หรือข้อมูลใด ๆ ที่ ARUN PLUS
          ได้รับจากผู้ใช้หรือผู้ติดต่อที่ผู้ใช้กำหนด ให้ถือว่าเป็นคำบอกกล่าว
          เอกสาร หนังสือ หรือข้อมูลของผู้ใช้ที่ถูกต้องแท้จริง
          เป็นไปตามความประสงค์โดยถูกต้องของผู้ใช้และมีผลผูกพันผู้ใช้ทุกประการ
        </DefaultParagraph>
        
      </div>
    </div>
  );
};

export default TermsThai;
